<template>
    <v-container>
        <v-layout column class="card">
            <v-form ref="form">
                <v-layout>
                    <v-flex xs10 mr-5>
                        <v-label>Nome da região *</v-label>
                        <v-text-field :rules="[rules.required]" v-input-filter="[filters.text,filters.numeric]"
                                      v-uppercase
                                      maxlength="100" v-model="model.nome"
                                      placeholder="Informe o nome da região"
                                      flat solo></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                        <v-label>Região padrão?</v-label>
                        <v-switch color="primary"
                                  :label="model.padrao | sn"
                                  v-model="model.padrao">
                        </v-switch>
                    </v-flex>
                </v-layout>
                <v-divider class="mt-4 mb-4"></v-divider>
                <v-layout row>
                    <v-layout column>
                        <v-flex xs10 mr-5>
                        <v-label>CEP inicial *</v-label>
                        <v-text-field :rules="[rules.required, rules.cep]" v-input-filter="[filters.cep]"
                                      maxlength="9" v-model="model.cep_inicio"
                                      placeholder="Informe o CEP inicial"
                                      return-masked-value
                                      mask='#####-###'
                                      outlined
                                      flat solo></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout column>
                        <v-flex xs10>
                        <v-label>CEP final *</v-label>
                        <v-text-field :rules="[rules.required, rules.cep]" v-input-filter="[filters.cep]"
                                      maxlength="9" v-model="model.cep_fim"
                                      placeholder="Informe o CEP final"
                                      return-masked-value
                                      mask='#####-###'
                                      flat solo></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-layout>
                <v-divider class="mt-4 mb-4"></v-divider>
                <v-layout wrap>
                    <v-flex xs12 sm6 lg4 xl3 v-for="(un,i) in model.gerentes" :key="i">
                        <v-layout class="box_ponto_venda" pa-3 pt-4 pb-4 column>
                            <v-flex>
                                <v-label>Gerente *</v-label>
                                <autocomplete v-model="un.id_gerente"
                                          :items="gerentes"
                                          item-text="nome"
                                          item-value="id_gerente"
                                          :rules="[rules.required]"
                                >
                                </autocomplete>
                            </v-flex>
                            <v-btn v-if="model.gerentes.length > 1"
                                   @click="rem(i)"
                                   class="btn-default btn-excluir-pv"
                                   color="dark"
                                   large outline>
                                <v-icon color="primary">ol-delete</v-icon>
                                <div class="pl-1">Excluir</div>
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-flex xs2>
                        <v-btn class="btn-default primary" @click="add">
                            Adicionar Gerente
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
            <v-layout mt-3>
                <v-flex xs2>
                    <v-btn class="btn-default primary" @click="salvar">Salvar</v-btn>
                </v-flex>
            </v-layout>
        </v-layout>
    </v-container>
</template>

<script>
import Rules from '../plugins/validation'
import Filters from '../plugins/filters'
import { alert, error, sleep } from '../plugins/helpers'
import { filter, pick } from 'lodash'

const listagem = 'regioes'

export default {
  computed: {
    rules () {
      return {
        ...Rules,
        unique: id => !id || filter(this.model.gerentes, (un) => id === un.id_gerente).length === 1 ||
            'Vendedor duplicado',
        cep: v => !v || (v && /^[0-9]{5}-[0-9]{3}$/.test(v)) || 'CEP inválido!'
      }
    },
    filters: () => Filters,
    id_regiao () {
      return this.model.id_regiao
    }
  },
  data: () => ({
    model: {
      id_regiao: null,
      padrao: false,
      cidades: [],
      cep_inicio: '',
      cep_fim: '',
      gerentes: []
    },
    cidades: [],
    gerentes: [],
    regioes: [],
    id_usuario: '',
    id_unidade_negocio: ''
  }),
  filters: {
    sn: (v) => v ? 'Sim' : 'Não'
  },
  methods: {
    add () {
      this.model.gerentes.push({ id_gerente: null })
    },
    rem (pos) {
      this.model.gerentes.splice(pos, 1)
    },
    salvar () {
      const form = this.$refs.form
      const edicao = this.model.id_regiao > 0
      this.model.id_unidade_negocio = this.$session.get('id_unidade_negocio')

      if (form.validate()) {
        (edicao
          ? this.$http.put(`/admin/regioes/${this.model.id_regiao}`, this.model)
          : this.$http.post('/admin/regioes', this.model)).then(() => {
          alert({
            text: `Região ${edicao ? 'alterada' : 'cadastrada'} com sucesso!`,
            buttons: {
              'OK': () => { this.$router.push({ name: listagem }) }
            }
          })
        }).catch(err => {
          error(err, 'Não foi possível salvar as informações.')
        })
      } else {
        form.resetValidation()
        sleep(100).then(() => form.validate())
      }
    },
    loadRegiao (id_regiao) {
      this.$http.get(`/admin/regioes/${id_regiao}`).then((r) => {
        const model = pick(r.data, ['id_regiao', 'nome', 'padrao', 'cep_inicio', 'cep_fim'])
        model.gerentes = r.data.gerentes.map(u => pick(u['pivot'], ['id_gerente']))
        this.model = model
        if (!model.gerentes.length) {
          this.add()
        }
      }).catch(this.fail)
    },
    loadgerentes () {
      this.$http.get('/admin/hierarquias/regiao/gerentes', {
        params: { id_usuario: this.id_usuario }
      }).then((r) => {
        r.data.forEach(r => {
          this.gerentes.push(r)
        })
      }).catch(this.fail)
    },
    loadRegioes (id_regiao) {
      this.$http.get('/admin/regioes', { params: { pagination: { sortBy: 'nome' } } }).then((r) => {
        this.regioes = r.data.items.filter((reg) => {
          return id_regiao !== reg.id_regiao
        })
      }).catch(this.fail)
    },
    fail (err) {
      error(err, 'Não foi possível recuperar as informações.')
    }
  },
  mounted () {
    const id_regiao = parseInt(this.$route.params['id_regiao'])
    this.id_usuario = this.$session.get('id_usuario')
    this.id_unidade_negocio = this.$session.get('id_unidade_negocio')
    if (id_regiao) {
      this.loadgerentes()
      this.loadRegiao(id_regiao)
    } else {
      this.loadgerentes()
    }

    this.add()
    this.loadRegioes(id_regiao)
  }
}
</script>

<style scoped>
    .box_ponto_venda {
        border: solid 1px #ccc;
        border-radius: 10px;
        margin: 10px;
    }

    .btn-default.btn-excluir-pv {
        margin: 0;
        width: 100%;
    }
</style>
